export const dynamicTable = {
  config: {
    Customer_List: {
      displayKey: "Customer_List",
      displayId: 1,
      queryId: 1,
      isShow: true,
      queryDataKey: "Customer_List",
      isCreate: false,
    },
    Customer_Detail: {
      displayKey: "Customer_Detail",
      displayId: 3,
      queryId: 3,
      isShow: true,
      queryDataKey: "Customer_Detail",
      isCreate: false,
    },
    Banner_List: {
      displayKey: "Banner_List",
      displayId: null,
      queryId: null,
      isShow: false,
      queryDataKey: "Banner_List",
      isCreate: true,
    },
    bcrm_data_management_summary: {
      displayKey: "bcrm_data_management_summary",
      displayId: null,
      queryId: null,
      isShow: false,
      queryDataKey: "bcrm_data_management_summary",
      isCreate: true,
    },
  },
};
